// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"0ee0148e","453":"4e5c15f6","806":"fbf20e9c"}[chunkId] + ".chunk.js";
};